<template>
  <v-container>
    <v-tabs color="transparent" v-model="tab" show-arrows>
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab v-for="(tabItem, index) in localizedTabs" :key="index">
        <span class="tabItem">
          {{ tabItem }}
        </span>
      </v-tab>
    </v-tabs>
    <v-card class="mt-2">
      <v-card-text>
        <v-layout align-center justify-space-between>
          <v-flex md4 ml-2>
            <v-layout align-center>
              <v-flex>{{ $t('fontSize') }}</v-flex>
              <v-radio-group v-model="orderNumberFontSize" row>
                <v-radio v-for="n in 3" :key="n" :label="`${radioLabel[n - 1]}`" :value="n"></v-radio>
              </v-radio-group>
            </v-layout>
          </v-flex>
          <v-flex md6>
            <v-layout align-center>
              <v-flex></v-flex>
              <v-flex md2>{{ $t('printMode') }}</v-flex>
              <v-checkbox :disabled="connectFailed" :label="$t('autoPrint')" v-model="autoPrint"></v-checkbox>
              <v-flex md2 v-if="connectFailed">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="openLink('https://qz.io/download/')" v-bind="attrs" v-on="on" color="black">
                      help_outline
                      small
                    </v-icon>
                  </template>
                  <span>{{ $t('autoPrintHelp') }}</span>
                </v-tooltip>
              </v-flex>
              <v-flex v-if="autoPrint" md6>
                <v-select v-model="selectPrinter" :items="printers" :label="$t('selectPrinter')"></v-select>
              </v-flex>
              <v-flex>
                <v-progress-circular v-if="loading" indeterminate color="primary">
                </v-progress-circular>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    
    <v-card class="mt-2" v-if="tab === 0">
      <v-card-text>
        <v-layout align-center justify-start>
          <v-flex md2 ml-2>
            <v-checkbox v-model="isSecondaryMatching" :label="$t('secondaryMatching')"></v-checkbox>
          </v-flex>
          <v-flex md4 ml-2 v-if="isSecondaryMatching">
            <v-text-field v-model.trim="secondaryMatchingText" :label="$t('suffix')"></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item v-for="(tab, index) in tabs" :key="index">
        <template v-if="index == 0">
          <v-layout column justify-center style="margin-top: 30px;">
            <v-flex xs12 class="text-center">
              <h2>{{ $t('uploadOrderPrint') }}</h2>
            </v-flex>
            <v-layout align-center row>
              <v-btn small color="primary" @click.stop="downloadTemplate('label-print.xlsx')">
                  {{ $t('template') }}
                </v-btn>
              <v-flex class="text-left">
                <v-btn small color="primary" title="importFile" :loading="uploading">
                  <v-icon dark left small>cloud_upload</v-icon>
                  {{ $t('upload') }}
                  <input v-on:click="clearSelectionCache" type="file" class="hideInput" @change="uploadFile"
                    accept=".csv,.xls,.xlsx" />
                </v-btn>
                {{ fileName }}
              </v-flex>
            </v-layout>

          </v-layout>
          <v-divider class="flex xs12 sm12  mt-3"></v-divider>
          <v-layout column class="my-3">
            <v-flex xs12 class="text-center">
              <h2>{{ $t('scanLabelPrinter') }}</h2>
            </v-flex>
            <v-layout align-center justify-space-between>
              <v-flex md8 xs8>
                <v-layout align-center>
                  <v-btn dark color="primary" small @click="selectFile">
                  <v-icon dark left small>folder_open</v-icon>
                  {{ $t('selectDirectory') }}
                </v-btn>
                <v-text-field class="ml-4" ref="barcodeInput" v-model="barcode" @keyup.enter="addBarcode"
                  :label="files.length ? $t('inputBarcodeHere', { forceMode: '' }) : $t('selectDirectoryFirst')"
                  autofocus></v-text-field>
                </v-layout>
              </v-flex>
              <v-flex md2>
                <v-text-field v-if="autoPrint" v-model="printQuantity" :label="$t('printQuantity')"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-if="directoryName">
              <v-flex xs12 ml-2 class="text-xs-left">
                <span>{{ $t('selectDirectoryName') }}</span>
                <span class="ml-1">{{ '/' + directoryName }}</span>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <div v-if="currentFile" style="display: flex; justify-content: center; height: 500px;">
                <iframe :src="currentFile.base64" style="width:100%; height:100%;" frameborder="0"></iframe>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="index == 1">
          <v-layout column class="my-3">
            <v-flex md3 class="text-center">
              <h2>{{ $t('convertBarcode') }}</h2>
            </v-flex>
            <v-layout align-center justify-space-between>
              <v-flex>
                <v-layout align-center>
                  <v-btn small color="primary" @click.stop="downloadTemplate('convert-barcode.xlsx')">
                    {{ $t('template') }}
                  </v-btn>
                  <v-flex md2>
                    <v-btn small color="primary" title="importFile">
                    <v-icon dark left small>cloud_upload</v-icon>
                    {{ $t('upload') }}
                    <input v-on:click="clearSelectionCache" type="file" class="hideInput"
                      @change="uploadFileForConvertBarcode" accept=".csv,.xls,.xlsx" />
                  </v-btn>
                  </v-flex>
                  <v-text-field class="ml-4" ref="convertBarcodeInput" v-model="barcode" @keyup.enter="addBarcode"
                    :label="uploadFileName ? $t('inputBarcodeHere', { forceMode: '' }) : $t('selectFileFirst')"
                    autofocus></v-text-field>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout v-if="uploadFileName">
              <v-flex xs12 ml-2 class="text-xs-left">
                <span>{{ $t('fileName') + ':' }}</span>
                <span class="ml-1">{{ uploadFileName }}</span>
              </v-flex>
            </v-layout>
            <v-layout justify-center align-center v-if="beforeConvertFile && currentConvertFile">
              <v-flex xs12>
                <div v-if="beforeConvertFile"
                  style="display: flex; justify-content: center; height: 378px; width: 578px;">
                  <iframe :src="beforeConvertFile.base64" style="width:100%; height:100%; transform: scale(0.8);"
                    frameborder="0"></iframe>
                </div>
              </v-flex>
              <v-flex>
                <v-icon style="font-size: 140px;">arrow_right</v-icon>
              </v-flex>
              <v-flex xs12>
                <div v-if="currentConvertFile"
                  style="display: flex; justify-content: center; height: 378px; width: 578px;">
                  <iframe :src="currentConvertFile.base64" style="width:100%; height:100%; transform: scale(0.8);"
                    frameborder="0"></iframe>
                </div>
              </v-flex>
            </v-layout>

          </v-layout>
        </template>
      </v-tab-item>
    </v-tabs-items>

  </v-container>
</template>
<script>
import {
  mediaTools,
  timeTools,
  warehouseTools,
  stringTools,
  readXlsxSheetData,
  matchTargetNavigator
} from '@/utils/tools'
import JsBarcode from 'jsbarcode'
import UploadFileWidget from './UploadFileWidget'
import html2canvas from 'html2canvas'
import qzTools from '@/utils/qzTools'
export default {
  name: 'LabelMapping',
  components: {
    UploadFileWidget
  },
  mixins: [mediaTools, timeTools, warehouseTools, stringTools, qzTools],
  computed: {
    localizedTabs () {
      return [this.$t('scanLabelPrinter'), this.$t('convertBarcode')]
    }
  },
  watch: {
    tab (v) {
      this.barcode = ''
    }
  },
  data () {
    return {
      files: [],
      autoPrint: false,
      directoryName: '',
      uploadFileName: '',
      barcode: '',
      currentFile: null,
      currentConvertFile: null,
      beforeConvertFile: null,
      tabs: ['ScanLabelPrinters', 'UploadPrinters'],
      radioLabel: [this.$t('Small'), this.$t('Medium'), this.$t('Large')],
      orderNumberFontSize: 2,
      isRotate: false,
      tab: 0,
      soundPitch: 1,
      loading: false,
      uploading: false,
      connectFailed: false,
      barcodesData: [],
      convertMap: {},
      printers: [],
      printQuantity: 1,
      selectPrinter: '',
      dateKeyStr: new Date().toISOString().slice(0, 10),
      fileName: '',
      isSecondaryMatching: false,
      secondaryMatchingText: 'A'
    }
  },
  methods: {
    downloadTemplate (filename) {
      this.$store.dispatch('downloadFile', {fullPath: `templates/${filename}`, name: `${filename}`})
    },
    async selectFile () {
      try {
        let files = await window.showDirectoryPicker()
        this.$refs.barcodeInput && this.$refs.barcodeInput[0].focus()
        await this.getFilesRecursively(files)
      } catch (e) {
        this.$store.dispatch('showToast', { info: e.message, level: 'error' })
      }
    },
    async getFilesRecursively (directoryHandle) {
      this.directoryName = directoryHandle.name
      for await (const entryHandle of directoryHandle.values()) {
        if (entryHandle.kind === 'file') {
          const file = await entryHandle.getFile()
          let fileName = file.name.split('.')[0]
          this.files.push({ name: fileName, file: file })
        }
      }
    },

    addBarcode (event) {
      const barcode = event.target.value
      if (this.tab === 0) {
        this.printFile(barcode)
      } else {
        this.convertBarcode(barcode)
      }
      event && event.target.select()
    },

    logLabelScanInLocalStorage () {
      let cache = window.localStorage.getItem('scanCache')
      if (!cache) {
        const initialCache = JSON.stringify({ dateKeyStr: this.dateKeyStr, scanItems: 1 })
        window.localStorage.setItem('scanCache', initialCache)
      } else {
        let cacheData = JSON.parse(cache)
        cacheData.scanItems++
        window.localStorage.setItem('scanCache', JSON.stringify(cacheData))
      }
    },
    convertFileToBase64 (file, callback) {
      const reader = new FileReader()
      
      reader.onload = (e) => {
        const base64Data = e.target.result.split(',')[1]
        const url = e.target.result
        callback(base64Data, url)
      }

      reader.onerror = (error) => {
        console.error('File reading error:', error)
      }

      reader.readAsDataURL(file)
    },
    handleMatchFile (fileName, fileItem) {
      this.logLabelScanInLocalStorage()
      this.convertFileToBase64(fileItem.file, (base64, url) => {
        this.currentFile = { name: fileName, file: fileItem, base64: url }
        const printJob = () => {
          if (this.autoPrint) {
            for (let i = 0; i < this.printQuantity; i++) {
              this.printData(base64, 'pdf')
            }
          } else {
            this.triggerPrint()
          }
        }
        printJob()
      })
    },
    printFile (fileName) {
      let fileItem = this.files.find(item => item.name === fileName)
      if (fileItem && fileItem.file) {
        this.playSound('success')
        this.handleMatchFile(fileName, fileItem)
      } else if (this.isSecondaryMatching && this.secondaryMatchingText) {
        const name = `${fileName}${this.secondaryMatchingText}`
        const target = this.files.find(item => item.name === name)
        if (target) {
          this.playSound('success')
          this.handleMatchFile(fileName, target)
        } else {
          this.playSound('warning')
          this.$store.dispatch('showToast', { info: this.$t('notFoundFile', { fileName }), level: 'error' })
        }
      } else {
        this.playSound('warning')
        this.$store.dispatch('showToast', { info: this.$t('notFoundFile', { fileName }), level: 'error' })
      }
    },
    printData (data, type) {
      const printData = [{
        type: type,
        format: 'base64',
        data: data
      }]

      this.printLabel(printData).then(() => {
        console.log('Print job complete!')
      }).catch(err => {
        console.error('Print job failed:', err)
      })
    },
    playSound (type) {
      if (type === 'hint') return this.hintSound(this.soundPitch)()
      if (type === 'success') return this.successSound(this.soundPitch)()
      if (type === 'warning') return this.warningSound(this.soundPitch)()
      return this.closeSound()
    },
    openLink (link) {
      window.open(link)
    },
    triggerPrint () {
      this.$nextTick(() => {
        const printFrame = document.querySelector('iframe')
        if (printFrame) {
          printFrame.onload = () => {
            setTimeout(() => {
              printFrame.contentWindow.focus()
              printFrame.contentWindow.print()
              this.$refs.barcodeInput && this.$refs.barcodeInput[0].focus()
            }, 200)
          }
          printFrame.src = printFrame.src
        }
      })
    },
    clearSelectionCache (e) {
      e.target.value = null
    },
    async uploadFile (e) {
      this.uploading = true
      try {
        const files = e.target.files
        this.fileName = files[0].name
        let rawData = await readXlsxSheetData(files, '')
        const trim = (str) => String(str || '').trim()
        let createData = (item) => {
          return {
            topText: trim(item['Inventory Number']),
            barcode: trim(item['Order Number'])
          }
        }

        let barcodesData = rawData.reduce((acc, item) => {
          let quantity = item['Quantity'] || 1
          let dataList = Array(quantity).fill().map(() => createData(item))
          return [...acc, ...dataList]
        }, [])
        this.uploading = false
        this.printAllBarcodes('orderNumberPrint', barcodesData)
        if (!rawData.length) {
          this.$store.dispatch('showToast', { info: this.$t('noData'), level: 'error' })
          return
        }
      } catch (error) {
        this.uploading = false
        this.$store.dispatch('showToast', { info: error })
      }
    },
    async uploadFileForConvertBarcode (e) {
      try {
        this.$refs.convertBarcodeInput && this.$refs.convertBarcodeInput[0].focus()
        const files = e.target.files
        this.uploadFileName = files[0].name
        let rawData = await readXlsxSheetData(files, '')
        rawData.forEach(item => {
          const originCode = item['Origin Code']
          this.convertMap[originCode] = {}
          this.convertMap[originCode].barcode = item['New Code']
          this.convertMap[originCode].topText = item['Top Text']
          this.convertMap[originCode].bottomText = item['Bottom Text']
          this.convertMap[originCode].quantity = isNaN(item['Quantity']) ? 1 : item['Quantity']
        })
        if (!rawData.length) {
          this.$store.dispatch('showToast', { info: this.$t('noData'), level: 'error' })
          this.uploading = false
          return
        }
      } catch (error) {
        this.uploading = false
        this.$store.dispatch('showToast', { info: error })
      }
    },
    convertBarcode () {
      if (this.convertMap[this.barcode]) {
        let barcodesData = []
        this.playSound('success')
        let number = this.convertMap[this.barcode]?.quantity || 1
        while (number) {
          number--
          barcodesData = [...barcodesData, { ...this.convertMap[this.barcode] }]
        }
        this.printAllBarcodes('convertBarcode', barcodesData)
        let beforeConvertBarcode = [{ barcode: this.barcode }]
        this.printAllBarcodes('convertBarcode', beforeConvertBarcode, 'isPrintBefore')
      } else {
        this.playSound('warning')
        this.$store.dispatch('showToast', { info: this.$t('notFoundFile', { fileName: this.barcode }), level: 'error' })
      }
    },
    printAllBarcodes (type, barcodesData, isPrintBefore) {
      const printContainer = document.createElement('div')
      document.body.appendChild(printContainer)

      printContainer.style.width = '6in'
      printContainer.style.display = 'flex'
      printContainer.style.flexDirection = 'column'
      printContainer.style.justifyContent = 'space-between'

      barcodesData.forEach((data, index) => {
        const page = document.createElement('div')
        page.style.textAlign = 'center'
        page.style.width = '6in'
        page.style.display = 'block'
        page.style.pageBreakInside = 'avoid'
        page.style.height = '4in'
        if (barcodesData.length === 1) {
          page.style.height = '3.9in'
        }
        const topText = document.createElement('div')
        const bottomText = document.createElement('div')
        const canvas = document.createElement('canvas')
        let barcodeFontSize
        let barcodeHeight

        switch (this.orderNumberFontSize) {
          case 1:
            barcodeFontSize = 16
            barcodeHeight = 180
            break
          case 2:
            barcodeFontSize = 28
            barcodeHeight = 180
            break
          case 3:
            barcodeFontSize = 36
            barcodeHeight = 180
            break
        }

        topText.textContent = data.topText
        topText.style.fontSize = `${barcodeFontSize}px`
        topText.style.fontWeight = 'bold'
        if (!data.bottomText) {
          topText.style.marginBottom = '30px'
          topText.style.marginTop = '30px'
        } else {
          topText.style.marginBottom = '20px'
          topText.style.marginTop = '10px'
        }

        bottomText.textContent = data.bottomText
        bottomText.style.fontSize = `${barcodeFontSize}px`
        bottomText.style.fontWeight = 'bold'
        bottomText.style.marginBottom = '30px'
        bottomText.style.marginTop = '20px'

        canvas.width = 600
        canvas.height = barcodeHeight
        canvas.style.width = '460px'
        canvas.style.height = `${barcodeHeight}px`
        canvas.style.margin = 'auto'

        JsBarcode(canvas, data.barcode, {
          format: 'CODE128',
          text: data.barcode,
          fontOptions: 'bold',
          fontSize: barcodeFontSize + 3,
          textAlign: 'center',
          textMargin: 5,
          lineColor: '#000',
          width: 2,
          height: barcodeHeight - 20,
          displayValue: true
        })

        page.appendChild(topText)
        page.appendChild(canvas)
        page.appendChild(bottomText)
        printContainer.appendChild(page)
      })

      if (!this.autoPrint || type === 'orderNumberPrint') {
        const printFrame = document.createElement('iframe')
        document.body.appendChild(printFrame)
        printFrame.style.position = 'absolute'
        printFrame.style.width = '0'
        printFrame.style.height = '0'
        printFrame.style.border = '0'

        const doc = printFrame.contentDocument || printFrame.contentWindow.document
        doc.open()
        doc.write('<head><style>@page { size: 6in 4in; margin: 0mm; }</style></head><body></body>')
        doc.close()
        doc.body.appendChild(printContainer)

        if (!isPrintBefore) {
          printFrame.contentWindow.print()
        }
        setTimeout(() => {
          document.body.removeChild(printFrame)
        }, 5000)
        html2canvas(printContainer, { scale: 1 }).then(canvas => {
          const imageData = canvas.toDataURL('image/png')
          if (isPrintBefore) {
            this.beforeConvertFile = { base64: imageData }
          } else {
            this.currentConvertFile = { base64: imageData }
          }
        })
      } else {
        html2canvas(printContainer, { scale: 1 }).then(canvas => {
          const imageData = canvas.toDataURL('image/png')
          const canvasData = imageData.split(',')[1]
          if (isPrintBefore) {
            this.beforeConvertFile = { base64: imageData }
          } else {
            this.printData(canvasData, 'image')
            this.currentConvertFile = { base64: imageData }
          }
          document.body.removeChild(printContainer)
        })
      }
    }
  },

  mounted () {
    this.initQZ()
    matchTargetNavigator(this.$i18n, {
      Chrome: 86,
      Edge: 86
    })
  },

  beforeDestroy () {
    this.disconnectQZ()
  }
}
</script>
<style>
.hideInput {
  position: absolute;
  top: 0;
  left: -15px;
  width: 100px;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/LabelMapping.vue